import {
  Box,
  Skeleton, ThemeProvider,
} from '@mui/material';
import { ContentTheme } from './ContentTheme';
import theme from '../../../assets/theme';

export default function ContentHomeSkeleton() {
  const numberOfCards = 1;
  return (
    <ThemeProvider theme={ContentTheme}>
      {[...Array(numberOfCards).keys()].map((item, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            padding: `${theme.spacing(10)} ${theme.spacing(4)}`,
          }}
        >
          <Skeleton
            sx={{
              width: '20%',
              height: 30,
            }}
            animation="wave"
          />
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
              },
              [theme.breakpoints.down('sm')]: {
                flexDirection: 'row',
                overflowX: 'auto',
                width: theme.spacing(112.5),
              },
              gap: theme.spacing(4),
            }}
          >
            {Array.from({ length: 3 }).map((itm, indx) => (
              <Box
                key={indx}
                sx={{
                  display: 'flex',
                  gap: theme.spacing(2.5),
                  flexDirection: 'column',
                  flex: '1 0 0',
                }}
              >
                {/* Hero Section Skeleton */}
                <Skeleton
                  sx={{
                    borderRadius: theme.spacing(1.25),
                    [theme.breakpoints.down('md')]: {
                      height: 180,
                    },
                    height: 250,
                  }}
                  animation="wave"
                  variant="rectangular"
                />

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: theme.spacing(1),
                    alignSelf: 'stretch',
                  }}
                >
                  {/* Header */}
                  <Skeleton
                    sx={{
                      width: '60%',
                      height: theme.spacing(3),
                    }}
                    animation="wave"
                  />
                  {/* Body */}
                  <Skeleton
                    sx={{
                      width: '100%',
                      height: theme.spacing(6),
                    }}
                    animation="wave"
                  />
                  {/* Footer */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignSelf: 'stretch',
                    }}
                  >
                    <Skeleton
                      sx={{
                        width: '40%',
                        height: theme.spacing(4),
                      }}
                      animation="wave"
                    />
                    <Skeleton
                      sx={{
                        width: '20%',
                        height: theme.spacing(4),
                      }}
                      animation="wave"
                    />
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </ThemeProvider >);
}
